import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { downloadFile } from '../downloadFile';

interface TransitProps {
  id: string;
}

export const useDownloadTransitFollowLetter = () => {
  return useMutation({
    mutationFn: ({ id }: TransitProps) => downloadFile(`transits/${id}/download-ncts-follow-letter`),
    onError: (error) => {
      showErrorToast(error, `Error downloading file!`);
    },
  });
};
